import React from "react";
import { Button } from "../../ui/General/Button/Button.tsx";
import styles from './LimitPages.module.css'

interface Props {
    maxPage: number,
    page: number,
    openNextPage: (page: number) => void,
}

export const LimitPages: React.FC<Props> = ({ maxPage, openNextPage, page, }) => {
    const handleChangePage = (newPage: number) => {
        openNextPage(newPage);
    }

    let pages = [];
    const pageOffset = () => {
        if (page >= 4) return page - 3;
        if (page <= 3) return 1;
        return page + 3;
    }
    const pageLimit = () => {
        if (maxPage <= (page + 2)) return maxPage;
        if (page === 1) return 6;
        if (page <= 3) return 5;
        return page + 2;
    }

    for (let i: number = pageOffset(); i <= pageLimit(); i++) {
        pages.push(
            <Button onClick={() => handleChangePage(i)} className={styles.pageBtn}
                style={page === i ? { backgroundColor: '#f39200' } : {}}>
                {i}
            </Button>
        )
    }

    return (<div style={{ display: 'flex' }}>
        {page !== 1 &&
            <Button onClick={() => handleChangePage(page - 1)} className={styles.pageBtn}>
                &lt;
            </Button>
        }
        {
            pages.map(page => {
                return page;
            })
        }
        {
            maxPage > (page + 2)
                ? <Button onClick={() => handleChangePage(page + 1)} className={styles.pageBtn}>
                    &gt;
                </Button>
                : null
        }
    </div>)
}